import { Link } from 'react-router';
import { EnvironmentUtils } from 'softcat:utils/environment.ts';

const { host } = globalThis.location;

export const Brand = () => {
    return (
        <Link className="inline-block flex-none rounded-xl text-xl font-semibold text-white focus:opacity-80 focus:outline-none" data-testid={'brand'} to="/">
            <span>Softcat</span>
            <small className="pl-1 text-sm font-normal">
                <span>v{import.meta.env.APP_VERSION}</span>-<span>{EnvironmentUtils.getShortName(host)}</span>
            </small>
        </Link>
    );
};
